<template>
  <div class="c-profile-cards__card tile c-contacts-tab">
    <div class="w-100 c-profile-card__cnt">
      <div class="c-profile-card__column">
        <div class="column__pad-right">
          <div class="c-profile-cards__emails">
            <template v-if="isArrayEmails">
              <div
                class="c-profile-cards__card__input w-100"
                v-for="(email, index) in emails"
                :key="index"
              >
                <Input
                  :value="email.email"
                  label="Email"
                  labelColor="#8a8497"
                  primary
                  disabled
                >
                  <template slot="icon">
                    <i
                      @click="emailRedirect(email.email)"
                      class="fas fa-edit"
                    ></i>
                  </template>
                </Input>
              </div>
            </template>
            <template v-if="!isArrayEmails">
              <div class="c-profile-cards__card__input w-100">
                <Input
                  :value="email"
                  label="Email"
                  labelColor="#8a8497"
                  primary
                  disabled
                >
                  <template slot="icon">
                    <i @click="emailRedirect" class="fas fa-edit"></i>
                  </template>
                </Input>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="c-profile-card__column">
        <div class="column__pad-left">
          <div class="c-profile-cards__card__input w-100">
            <Input
              :value="phone"
              label="Numero di telefono"
              labelColor="#8a8497"
              primary
              v-if="phone"
              disabled
            >
              <template slot="icon">
                <i @click="phoneRedirect" class="fas fa-edit"></i>
              </template>
            </Input>
          </div>
          <div class="c-profile-cards__social-cnt">
            <div v-if="isSocials" class="c-profile-cards__social__title">
              {{ $t("Social Network") }}
            </div>
            <div v-if="isSocials" class="c-profile-cards__social">
              <div
                class="c-profile-cards__social__item"
                v-for="(social, index) in socials"
                :key="index"
              >
                <div class="c-profile-cards__social__icon">
                  <i :class="social[0].presenter.icon.class"></i>
                </div>
                <p class="c-profile-cards__social__name">
                  {{ social[0].presenter.to_show }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from "../common/Inputs/Input";

import { mapGetters } from "vuex";
export default {
  name: "ContactsTab",
  components: { Input },
  computed: {
    ...mapGetters(["getUser"]),
    isSocials() {
      return Object.keys(this.socials).length;
    },
    isArrayEmails() {
      return Array.isArray(this.emails);
    }
  },
  data() {
    return {
      email: "",
      phone: "",
      emails: [],
      socials: {}
    };
  },
  methods: {
    emailRedirect(email) {
      if (email) {
        this.$router.push({
          name: "editAddress",
          params: { address: { email } }
        });
      } else {
        this.$router.push({
          name: "editAddress",
          params: { address: { email: this.email } }
        });
      }
    },
    phoneRedirect() {
      this.$router.push("/verify/mobile");
    }
  },
  watch: {
    getUser: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val.id) {
          this.email = val.profile.email ? val.profile.email.email : "";

          this.phone = val.profile.mobile ? val.profile.mobile.number : "";

          this.socials = val.socials;
          this.emails = val.profile.emails;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.c-profile-cards__social-cnt {
  min-height: 200px;
}
i {
  cursor: pointer;
}
.c-profile-cards__emails {
  display: flex;
  flex-direction: column;
}
.c-profile-card__cnt {
  display: flex;
  flex-direction: column-reverse;
  @media (min-width: 992px) {
    flex-direction: row;
  }
}
.c-profile-card__column {
  @media (min-width: 992px) {
    flex: 0 0 50%;
    max-width: 50%;
  }
}
.column__pad-right {
  @media (min-width: 992px) {
    padding-right: 20px;
  }
}
.column__pad-left {
  @media (min-width: 992px) {
    padding-left: 20px;
  }
}
</style>
